import { api } from '@/shared/api/client';

import type { TriageActivation } from './types';

export const activationKeys = {
  activation: ['triage', 'activation'] as const,
};

export const activationApi = {
  /** What the triage is allowed to do, and where. Admin only; 403 for anybody else. */
  activation: (): Promise<TriageActivation> => api.get<TriageActivation>('/api/triage/activation'),
};
